import * as React from "react";
import { forwardRef } from "react";
const SvgIconRecentFile = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6 4v11.333h1.333v-10h10V18A.667.667 0 0 1 16 18v-2H4v2a2.01 2.01 0 0 0 2 2h10.667a2.01 2.01 0 0 0 2-2V4zm-.667 13.333h9.333V18a2 2 0 0 0 .125.667H6A.655.655 0 0 1 5.333 18z", "data-name": "icon/document", transform: "translate(-3.333 -4)", fill: "#57728a" }));
const ForwardRef = forwardRef(SvgIconRecentFile);
export { ForwardRef as ReactComponent };
